import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { BsSuitHeartFill } from "react-icons/bs";
import { GiReturnArrow } from "react-icons/gi";
import { FaShoppingCart } from "react-icons/fa";
import { MdOutlineLabelImportant } from "react-icons/md";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import SwiperCore, { Autoplay } from "swiper";
import { formatPrice } from "../../../constants/funciones";
import { useDispatch } from "react-redux";
import { addToCart } from "../../../redux/orebiSlice";
import Swal from "sweetalert2";
import { UserConfigContext } from "../../../context/UserConfigContext";
import PriceConsultationButton from "../../common/PriceConsultationButton";

SwiperCore.use([Autoplay]);

const ProductsOnSale = ({ relatedProducts }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { config1, configEcommerce } = useContext(UserConfigContext);
  const contactEmailsSource = config1?.config_ecommerce?.emails_contactos || configEcommerce?.emails_contactos || [];
  const contactEmails = (Array.isArray(contactEmailsSource) ? contactEmailsSource : String(contactEmailsSource).split(/[;,]/))
    .map((email) => typeof email === "string" ? email.trim() : email?.email || email?.mail || email?.correo)
    .filter(Boolean);

  const idString = (name) => {
    return String(name)
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^\w-]/g, "");
  };

  const handleProductDetails = (product) => {
    const rootId = idString(product.Descripcion);
    navigate(`/product/${rootId}`, {
      state: { item: product },
    });
  };

  const handleAddToCart = (product) => {
    if (configEcommerce?.ocultar_precio || Number(product.ocultar_precio) === 1) {
      Swal.fire({
        icon: "info",
        title: "Precio a consultar",
        text: contactEmails.length
          ? `Comuníquese con nosotros a: ${contactEmails.join(", ")}`
          : "Comuníquese con nosotros para consultar el precio.",
        confirmButtonText: "Entendido",
      });
      return;
    }

    dispatch(
      addToCart({
        ...product,
        quantity: 1,
      })
    );
  };

  return (
    <div>
      <h3 className="font-titleFont text-2xl font-semibold mb-6 decoration-[1px]">
        Productos relacionados
      </h3>
      <div className="w-full mx-auto">
        <Swiper
          spaceBetween={30}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          loop
          breakpoints={{
            640: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
          }}
        >
          {relatedProducts.map((product) => (
            <SwiperSlide key={product.codigo} className="p-4">
              <div className="w-full relative group border rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="w-full relative overflow-hidden">
                  <button type="button" onClick={() => handleProductDetails(product)} className="w-full">
                    <img
                      className="w-full h-auto object-cover cursor-pointer"
                      src={product.img}
                      alt={product.Descripcion}
                    />
                  </button>
                  <div className="absolute bottom-0 w-full bg-white transition-transform duration-700 transform translate-y-full group-hover:translate-y-0">
                    <ul className="flex flex-col gap-2 font-titleFont px-2">
                      <li className="text-[#767676] hover:text-primeColor text-sm border-b border-b-gray-200 flex items-center justify-between pb-1 cursor-pointer duration-300">
                        Compartir
                        <GiReturnArrow />
                      </li>
                      <li
                        onClick={() => handleAddToCart(product)}
                        className="text-[#767676] hover:text-primeColor text-sm border-b border-b-gray-200 flex items-center justify-between pb-1 cursor-pointer duration-300"
                      >
                        Agregar al carrito
                        <FaShoppingCart />
                      </li>
                      <li
                        onClick={() => handleProductDetails(product)}
                        className="text-[#767676] hover:text-primeColor text-sm border-b border-b-gray-200 flex items-center justify-between pb-1 cursor-pointer duration-300"
                      >
                        Ver detalles
                        <MdOutlineLabelImportant className="text-lg" />
                      </li>
                      <li className="text-[#767676] hover:text-primeColor text-sm border-b border-b-gray-200 flex items-center justify-between pb-1 cursor-pointer duration-300">
                        Agregar a favoritos
                        <BsSuitHeartFill />
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="max-w-80 py-4 flex flex-col gap-1 border-t border-gray-200 px-4">
                  <p className="text-[#767676] text-[14px]">C\u00f3digo: {product.codigo}</p>
                  <h2 className="text-lg text-primeColor font-bold">{product.Descripcion}</h2>
                  <p className="text-[#767676] text-[14px]">
                    {configEcommerce?.ocultar_precio || Number(product.ocultar_precio) === 1 ? (
                      <PriceConsultationButton className="text-amber-700 underline decoration-dotted underline-offset-2">
                        {product.ocultar_precio_texto || "Precio a consultar"}
                      </PriceConsultationButton>
                    ) : product.PrecioOferta > 0 ? (
                      <>
                        <span style={{ textDecoration: "line-through" }}>
                          {product.simbolo}
                          {formatPrice(product.PrecioLista)}
                        </span>{" "}
                        &nbsp;
                        <span>
                          {" "}
                          {product.simbolo}
                          {formatPrice(product.PrecioOferta)}
                        </span>
                      </>
                    ) : (
                      <span>
                        {product.simbolo} {formatPrice(product.PrecioLista)}
                      </span>
                    )}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ProductsOnSale;
